import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { config } from '../../common/';
import * as ContractsInvoices from '../../contractsinvoices';

const BaseLayout: React.FC<{}> = () => (
    <Route
        render={() => {
            return (
                <React.Fragment>
                    <Switch>
                        <Route exact path={[`${config.BaseURL}/contractsinvoices`, `${config.AlternativeBaseURL}/contractsinvoices`]} component={ContractsInvoices.ContractsLayout} />
                    </Switch>
                </React.Fragment>
            );
        }}
    />);

export default BaseLayout;
